import React, {useEffect, useState} from "react";
import visual from "../assets/images/visual_bea_ita.png";
import {Box, Button, Grid, Grow} from "@mui/material";
import CustomButton from "./user/CustomButton";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {UserMessaggi} from "./user/UserMessaggi";
import UserFoto from "./user/UserFoto";
import UserPoll from "./user/UserPoll";
import {CameraEnhance, FilterDrama, Message} from "@mui/icons-material";
import {useDocument} from "react-firebase-hooks/firestore";
import {firestore} from "../firebase/clientApp";
import CustomHeader from "./user/CustomHeader";
import _ from 'lodash'
import clap from "../assets/images/clap.png"
import beaItaliaTheme from "../themes/beaItaliaTheme";
import WrapperInterazione from "./user/WrapperInterazione";

function HomeUI({pulsantiera: pulsantiAttivi}) {
    const navigate = useNavigate()

    return (
        <>
            <header className="App-header">
                <CustomHeader disableBack/>
                <Grow in={true} exit={true} timeout={600}>
                    <Box display={'flex'}>
                        <img src={visual} alt="visual" style={{maxWidth: '450px', width: '78%', margin: 'auto'}}/>
                    </Box>
                </Grow>
            </header>
            <Grow in={true} exit={true} timeout={600}>
                <Grid px={3} my={1} container spacing={2} alignItems={'center'} justifyContent={'center'}
                      sx={{position: 'absolute', bottom: '160px', left: 0, right: 0}}>
                    {/*<Typography variant={'h4'} fontWeight={'bold'}>Invia...</Typography>*/}
                    {
                        pulsantiAttivi.map((pulsante, i) => {
                            if(pulsante.path === 'cta')
                                return <Grow key={i} in={true} exit={true} timeout={600 * (i + 1)}>
                                    <Grid item xs={pulsante.xs}>
                                        <Button key={i} sx={{
                                            mt: 2,
                                            fontWeight: 'bold',
                                            borderRadius: '1.4rem',
                                            maxHeight: '55px',
                                            //background: '#E77535',
                                            color: beaItaliaTheme.palette.primary.main,
                                            background: beaItaliaTheme.palette.text.primary,
                                            border: 'none',
                                            boxShadow: '3px 5px 8px 0px #3b56a7a6, -2px -1px 8px hsl(226deg 23% 82%), 6px 6px 8px rgb(255 255 255 / 8%), 6px 6px 10px rgb(0 0 0 / 15%)'
                                        }}
                                                fullWidth
                                                variant={'standard'}
                                                onClick={() => navigate(pulsante.path)}
                                        >
                                            {pulsante.label}
                                            {pulsante.icon}
                                        </Button>
                                    </Grid>
                                </Grow>
                            return !pulsante.hidden &&
                                <Grow key={i} in={true} exit={true} timeout={600 * (i + 1)}>
                                    <Grid item xs={pulsante.xs}>
                                        <CustomButton
                                            label={pulsante.label}
                                            onClick={() => navigate(pulsante.path)}
                                            icon={pulsante.icon}
                                        />
                                    </Grid>
                                </Grow>
                            }
                        )
                    }
                </Grid>
            </Grow>
        </>
    );
}

export const pulsantiera = [
    {path: "cta", label: "Scopri di più", subtitle: "Vuoi saperne di più? Scrivi qui la tua mail per essere ricontattato!", description: "Servizi e prodotti digitali per innovare l’esperienza delle audience nel mondo degli eventi e degli spettacoli dal vivo.",
        children: <UserMessaggi cta/>, icon: <img src={clap} width={'30%'} style={{maxWidth: '100px'}}/>, xs: 12, plesh: true, hidden: false},
    /*{path: "messaggi", label: "Invia un Messaggio", subtitle: "Il messaggio che invierai potrà essere mostrato sul palco!",
        children: <UserMessaggi/>, icon: <Message fontSize={'large'} color={'secondary'}/>, xs: 12, hidden: false},
    {path: "wordcloud", label: "Wordcloud", title: "In una parola, per te Live Free significa…?", description: "Da tutte le parole raccolte l'Intelligenza Artificiale genererà l'immagine rappresentativa del BEA che sarà mostrata a fine evento",
        children: <UserMessaggi wordStorm/>, icon: <FilterDrama fontSize={'large'} color={'secondary'}/>, xs: 12, hidden: false},
    {path: "foto", label: "Invia una Foto", subtitle: "Invia la tua foto ed entra a far parte dello show! La tua foto apparirà sul palco",
        children: <UserFoto/>, icon: <CameraEnhance fontSize={'large'} color={'secondary'}/>, xs: 12, hidden: false},*/
]

export const Home = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [openSections,] = useDocument(firestore.doc('test/sezioniAperte/'))
    const [pulsantiAttivi, setPulsantiAttivi] = useState(pulsantiera)

    const [quizPlaying, quizIdLoading, quizIdError] = useDocument(firestore.doc('test/quiz/'))
    const [quizData, setQuizData] = useState(null)

    useEffect(() => {
        if(openSections && openSections.data()) {
            const visible = openSections.data()
            if(!visible[location.pathname]) {
                navigate('/')
            }
            setPulsantiAttivi(_.filter(pulsantiera, function (o) {
                return visible[o.path]
            }))
        }
    }, [openSections])

    useEffect(() => {
        if(quizPlaying && quizPlaying.data().show) {
            console.log("quizPlaying:",quizPlaying.data())
            var docRef = firestore.collection(`test/data/quizzes/`).doc(quizPlaying.data().id);
            docRef.get().then((doc) => {
                if (doc.exists) {
                    setQuizData(doc.data())
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });

            //console.log("quizData:",quizData)
            navigate('/'+quizPlaying.data().id)
        } else {
            navigate('/')
        }
    }, [quizPlaying])

    useEffect(() => {
        if(quizPlaying && !quizIdLoading) {
        }
    }, [quizPlaying])

    return (
            <Routes>
                <Route index element={<HomeUI pulsantiera={pulsantiAttivi}/>}/>
                {
                    pulsantiera.map((pulsante, i) =>
                        <Route key={i} path={pulsante.path}
                               element={<WrapperInterazione title={pulsante.title||pulsante.label} subtitle={pulsante?.subtitle} description={pulsante.description}
                                                            children={pulsante.children} plesh={pulsante.plesh}/>}/>
                    )
                }
                {quizPlaying && quizData && <Route path={'/:id'} element={<UserPoll quizLoading={quizIdLoading} quizPlayingId={quizPlaying.data().id} quiz={quizData}/>}/>}
                {/*<Route path={'/:id'} element={<UserPoll quizLoading={quizIdLoading} quiz={quizPlaying?.data()}/>}/>*/}
            </Routes>
    )
}